module.exports = __webpack_public_path__ + "static/media/pl-reports.d3b9f68d.svg";